const ErrorCharacter = () => {
  return (
    <svg
      width="440"
      height="290"
      viewBox="0 0 376 216"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="14.7461"
        y="93.0352"
        width="5.70816"
        height="93.5092"
        rx="2.85408"
        fill="#FFBB56"
      />
      <rect
        x="109.407"
        y="73.5742"
        width="5.70816"
        height="110.597"
        rx="2.85408"
        fill="#FFBB56"
      />
      <path
        d="M12.3682 104.531C12.3682 101.212 14.6998 98.3485 17.9507 97.6763L110.027 78.637C114.371 77.7388 118.445 81.0561 118.445 85.492V127.107C118.445 130.427 116.113 133.29 112.862 133.962L20.7856 153.001C16.4416 153.899 12.3682 150.582 12.3682 146.146V104.531Z"
        fill="black"
      />
      <rect
        x="152.693"
        y="187.018"
        width="7.11999"
        height="110.833"
        rx="3.56"
        transform="rotate(90 152.693 187.018)"
        fill="#FFBB56"
      />
      <rect
        x="166.013"
        y="140.977"
        width="7.11999"
        height="110.833"
        rx="3.56"
        transform="rotate(90 166.013 140.977)"
        fill="#FFBB56"
      />
      <path
        d="M0.846978 155.917C6.03539 111.547 54.081 96.7765 76.7966 96.2078C147.937 90.6609 147.763 146.454 147.937 187.018L0.0506877 187.018C0.0514537 175.645 -0.301966 165.742 0.846978 155.917Z"
        fill="#6C65D9"
      />
      <path
        d="M44.2384 112.971C29.2061 91.7514 49.1746 80.8714 62.2821 77.6991C63.0749 77.5072 63.8468 78.0453 63.9727 78.8496L64.8554 84.4868C64.904 84.7975 64.8482 85.1155 64.6967 85.3913L57.4678 98.5453C57.114 99.189 57.3151 99.998 57.9154 100.422C88.1586 121.805 92.879 163.537 92.7713 185.392C92.7674 186.171 92.1314 186.782 91.3514 186.782H62.4101C61.5855 186.782 60.933 186.09 60.9747 185.268C61.8617 167.78 59.3912 134.361 44.2384 112.971Z"
        fill="#A09AFB"
      />
      <path
        d="M112.498 103.715C116.593 90.1364 105.442 84.4914 97.9899 82.8301L39.9569 100.155C34.439 101.484 33.0596 107.196 33.0596 109.886C38.7677 107.608 47.0129 110.835 50.4219 112.734C78.2492 128.232 104.412 130.534 112.498 103.715Z"
        fill="#A09AFB"
      />
      <path
        d="M108.657 142.778C109.4 134.708 101.074 113.769 96.0693 102.64C95.7783 101.993 96.2731 101.27 96.983 101.301L112.467 101.957C112.817 101.971 113.131 102.177 113.283 102.492L133.265 143.801C133.455 144.192 133.356 144.667 133.002 144.921C126.992 149.226 119.267 144.417 109.692 144.015C109.067 143.988 108.6 143.4 108.657 142.778Z"
        fill="#A09AFB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.74 112.36C107.21 112.595 107.4 113.165 107.165 113.634C104.907 118.14 101.395 121.116 96.5128 123.552C96.0428 123.786 95.4714 123.596 95.2364 123.127C95.0014 122.658 95.1919 122.088 95.6618 121.854C100.293 119.543 103.441 116.822 105.464 112.785C105.698 112.316 106.27 112.126 106.74 112.36Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.2932 110.288C66.5953 109.859 67.1886 109.756 67.6185 110.057C76.6632 116.4 81.5036 126.362 84.8449 134.935C85.0353 135.424 84.7927 135.974 84.303 136.164C83.8133 136.354 83.262 136.112 83.0715 135.624C79.7532 127.109 75.0801 117.61 66.5246 111.611C66.0947 111.309 65.9911 110.717 66.2932 110.288Z"
        fill="#252A38"
      />
      <path
        d="M51.641 86.8837C60.7455 81.4326 74.023 81.584 79.5236 82.3411C91.6631 83.8553 113.438 89.6092 103.423 100.512C93.4083 111.414 73.8334 107.325 65.2978 103.918C56.952 100.511 42.5364 92.3347 51.641 86.8837Z"
        fill="#252A38"
      />
      <path
        d="M62.4528 102.784L61.8838 72.6895L93.7497 82.9102L95.4568 105.623C86.3522 110.166 69.2812 106.191 62.4528 102.784Z"
        fill="#E5986D"
      />
      <path
        d="M94.8875 95.9691C83.962 97.7862 72.8848 88.7768 68.7119 84.0449L94.3184 87.4518L94.8875 95.9691Z"
        fill="#252A38"
      />
      <path
        d="M104.748 52.6157C107.614 70.8958 104.961 87.1392 92.0426 89.1555C69.8503 92.6193 60.8329 78.1973 57.9675 59.9173C55.1021 41.6373 63.2515 25.1838 76.1697 23.1676C89.0878 21.1513 101.883 34.3357 104.748 52.6157Z"
        fill="#E6986D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M96.3211 44.9018C95.223 44.9391 94.1909 45.3914 93.6045 45.7878C93.0841 46.1395 92.3765 46.0036 92.024 45.4843C91.6716 44.965 91.8077 44.2589 92.3281 43.9072C93.1896 43.325 94.6301 42.6866 96.2437 42.6319C97.9154 42.5751 99.7537 43.1527 101.207 44.9753C101.598 45.4661 101.517 46.1805 101.025 46.571C100.533 46.9615 99.817 46.8802 99.4257 46.3894C98.4739 45.1956 97.3612 44.8665 96.3211 44.9018Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M80.9421 50.0829C81.5695 50.0307 82.1289 50.4114 82.1916 50.933L82.7624 55.6796C82.8251 56.2013 82.3674 56.6665 81.7401 56.7187C81.1127 56.7708 80.5533 56.3902 80.4906 55.8685L79.9198 51.122C79.8571 50.6003 80.3148 50.1351 80.9421 50.0829Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.115 48.6591C97.7423 48.6069 98.3017 48.9875 98.3645 49.5092L98.9352 54.2558C98.998 54.7775 98.5403 55.2427 97.9129 55.2948C97.2856 55.347 96.7262 54.9664 96.6634 54.4447L96.0927 49.6981C96.0299 49.1765 96.4876 48.7112 97.115 48.6591Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.6343 46.5845C79.4929 46.3198 77.8121 48.3302 77.3897 49.256C77.1292 49.8268 76.4544 50.0788 75.8823 49.8189C75.3103 49.559 75.0577 48.8856 75.3182 48.3148C76.0294 46.7562 78.4861 43.9556 82.8259 44.3213C83.4522 44.3741 83.917 44.9235 83.8641 45.5485C83.8112 46.1735 83.2606 46.6373 82.6343 46.5845Z"
        fill="#1B1D28"
      />
      <path
        d="M69.101 56.3237C70.1295 62.8848 69.1773 68.7149 64.5407 69.4386C56.5754 70.6818 53.3389 65.5055 52.3104 58.9444C51.282 52.3833 54.2069 46.4778 58.8436 45.7541C63.4802 45.0304 68.0726 49.7626 69.101 56.3237Z"
        fill="#E6986D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56.7074 56.9375C57.3359 56.9375 57.8455 57.4459 57.8455 58.0731C57.8455 58.8353 57.9773 59.9578 58.3331 60.8454C58.7027 61.7674 59.1278 62.0479 59.5526 62.0479C60.1811 62.0479 60.6906 62.5563 60.6906 63.1835C60.6906 63.8107 60.1811 64.3192 59.5526 64.3192C57.7012 64.3192 56.7037 62.8962 56.2198 61.6889C55.722 60.4471 55.5693 59.0144 55.5693 58.0731C55.5693 57.4459 56.0789 56.9375 56.7074 56.9375Z"
        fill="#1B1D28"
      />
      <path
        d="M64.6924 50.3164C67.5465 65.031 70.6859 72.5308 83.2439 72.151C86.6205 72.0489 89.5349 71.8041 92.044 71.407L94.898 69.303L98.7035 69.6286C102.208 68.1397 104.125 66.1218 105.169 63.2624C105.351 62.7667 106.09 62.802 106.119 63.3287C106.583 71.5169 104.204 87.748 92.9954 89.951C81.4531 92.2196 67.2765 89.2466 61.6003 74.5244C56.8437 66.455 65.406 68.1164 59.46 54.8257L64.6924 50.3164Z"
        fill="#C9C9C9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M99.9128 73.1026C100.088 73.7064 99.7684 74.3464 99.1989 74.5321L92.1864 76.8196C91.617 77.0054 91.0133 76.6666 90.838 76.0628C90.6628 75.4591 90.9824 74.8191 91.5519 74.6333L98.5644 72.3458C99.1338 72.16 99.7376 72.4989 99.9128 73.1026Z"
        fill="#1B1D28"
      />
      <path
        d="M106.624 72.8441C99.7342 75.4592 96.1307 72.2168 94.9121 69.6842C94.7314 69.3085 94.7738 68.8633 95.0216 68.5277C97.9166 64.6059 103.492 67.746 106.987 70.7006C107.733 71.3316 107.538 72.497 106.624 72.8441Z"
        fill="#ECECEC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M91.6242 53.9221C92.1945 53.7524 92.7946 54.0761 92.9646 54.6451C93.7003 57.1064 94.66 59.0185 95.5016 60.6955C95.8671 61.4237 96.2103 62.1076 96.5033 62.7728C96.9575 63.8044 97.3284 64.8874 97.2243 65.943C97.11 67.1032 95.7395 68.4912 94.6319 69.2217C94.1354 69.549 93.467 69.4128 93.139 68.9175C92.8109 68.4221 92.9474 67.7551 93.4438 67.4278C94.1583 66.9566 95.0446 66.0902 95.0799 65.7326C95.1254 65.2703 94.9675 64.63 94.5305 63.6379C94.3026 63.1202 94.004 62.5244 93.6682 61.8541C92.8036 60.1286 91.6918 57.9096 90.8997 55.2596C90.7297 54.6906 91.054 54.0918 91.6242 53.9221Z"
        fill="#1B1D28"
      />
      <path
        d="M78.9992 73.2216C88.4658 76.0382 93.4628 72.6734 95.2052 69.9761C95.488 69.5383 95.4242 68.9678 95.0596 68.5951C91.0658 64.511 83.4619 67.8068 78.6606 70.9345C77.727 71.5427 77.9308 72.9037 78.9992 73.2216Z"
        fill="#ECECEC"
      />
      <path
        d="M58.7463 55.0626C49.0087 54.0759 46.8078 43.8717 46.7719 40.4832C38.201 34.3645 44.8111 29.1544 49.1875 27.3141C49.1875 23.9725 51.8489 18.2761 67.7841 12.1056C87.6978 4.39461 102.664 7.59107 109.168 17.3267C113.449 23.7351 112.285 25.8887 110.381 28.5927C99.4073 39.2584 84.4616 35.7367 78.3604 32.6426C72.7477 41.1199 64.2327 43.0951 60.6767 43.023C64.1923 46.3872 68.4839 56.0493 58.7463 55.0626Z"
        fill="#ECECEC"
      />
      <path
        d="M95.6116 187.258C90.6944 190.529 84.3202 191.983 83.5918 194.345L66.1084 183.987C89.0553 174.173 92.3334 184.532 95.6116 187.258Z"
        fill="#E5986D"
      />
      <path
        d="M19.6687 215.605C3.27806 212.333 -0.000170126 194.888 6.62164e-09 185.074L24.586 186.165L61.738 180.713C77.473 179.841 85.2312 188.89 85.7776 194.888C86.3239 200.885 36.0593 218.877 19.6687 215.605Z"
        fill="#6C65D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.8885 185.014C79.2246 184.53 79.8906 184.409 80.3761 184.744C81.6396 185.617 83.4994 187.218 85.0545 189.238C86.5987 191.243 87.9393 193.789 87.9393 196.526C87.9393 197.115 87.4606 197.592 86.8701 197.592C86.2796 197.592 85.801 197.115 85.801 196.526C85.801 194.465 84.7741 192.376 83.3588 190.538C81.9545 188.714 80.263 187.262 79.1589 186.499C78.6734 186.164 78.5523 185.499 78.8885 185.014Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59.3433 181.849C59.9223 181.733 60.4856 182.108 60.6014 182.686C60.7172 183.264 60.3417 183.826 59.7627 183.941C52.8284 185.325 46.592 185.463 42.0886 185.256C39.8357 185.152 38.0129 184.962 36.7489 184.796C36.1168 184.714 35.6241 184.637 35.2869 184.581C35.1183 184.553 34.9885 184.53 34.8996 184.514C34.8551 184.505 34.8209 184.499 34.7971 184.494L34.7693 184.489L34.7613 184.487L34.7588 184.487C34.7585 184.487 34.7573 184.487 34.967 183.44"
        fill="#252A38"
      />
      <path
        d="M159.95 108.592L154.672 115.533C153.877 116.58 154.204 118.092 155.361 118.714L165.963 124.418C166.488 124.701 167.107 124.75 167.67 124.555L204.12 111.91C206.394 111.121 205.829 107.75 203.422 107.75H161.647C160.981 107.75 160.354 108.062 159.95 108.592Z"
        fill="#E5986D"
      />
      <path
        d="M176.964 129.45C165.871 142.151 157.21 168.249 152.475 183.929C151.735 186.377 149.051 187.661 146.676 186.698L122.53 176.907C120.588 176.119 119.48 174.055 119.998 172.029C126.429 146.901 143.759 123.518 153.717 112.643C155.036 111.202 157.171 110.912 158.877 111.868L175.998 121.469C178.771 123.024 179.053 127.057 176.964 129.45Z"
        fill="#6C64D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M143.075 123.97C143.551 124.301 143.667 124.953 143.334 125.425C139.656 130.644 133.448 139.91 130.87 150.155C130.729 150.715 130.158 151.055 129.594 150.915C129.03 150.775 128.688 150.208 128.829 149.648C131.509 138.997 137.925 129.457 141.61 124.227C141.944 123.754 142.6 123.639 143.075 123.97Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M169.56 117.704C169.871 117.125 170.554 116.929 171.086 117.267L177.78 121.518C178.312 121.856 178.492 122.599 178.182 123.179C177.871 123.758 177.188 123.954 176.656 123.616L169.962 119.365C169.43 119.027 169.25 118.284 169.56 117.704Z"
        fill="#252A38"
      />
      <path
        d="M130.353 69.4357C132.685 68.0956 135.063 66.3789 136.685 65.1104C137.244 64.6726 138.058 64.7471 138.462 65.3313C140.238 67.9025 141.428 71.19 142.303 73.4337C142.473 73.871 135.875 73.2783 130.678 72.4682C129.355 72.2617 129.192 70.1029 130.353 69.4357Z"
        fill="#F9F9F9"
      />
      <rect x="137" y="5" width="216" height="98" rx="10" fill="#F9F9F9" />
    </svg>
  );
};

export default ErrorCharacter;
